import React, { useEffect, useState } from "react";
import style from "./donation.module.css";
import { Col, Row, Modal, Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useGetUser from "../../customHook/useGetUser";
import { getToken } from "../../utils/api";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
import {
  AdminPayment,
  createAdminSubscription,
} from "../../apis/paymentApis";
import Pray from "./pray";
import { getAllCenters } from "../../apis/CenterApis";

const DonateModal = ({show,onHide,prefill }) => {
  useGetUser();
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const location = useLocation();

  // Donation form states
  const [amount, setSelectedAmount] = useState("");
  const [selectedFrequency, setSelectedFrequency] = useState("month");
  const [id, setId] = useState("");
  const [usercomment, setUserComment] = useState("");
  const [email, setEmail] = useState("");
  const [fullName, setFullName] = useState("");
  const [selectedCenter, setSelectedCenter] = useState("");
    const [sendInvoiceConsent, setSendInvoiceConsent] = useState(false);

  // Example center list (you can replace this with an API or prop)
const [centerList,setCenterList]=useState([]);
  const handleFrequencyChange = (e) => setSelectedFrequency(e.target.value);

 useEffect(() => {
    if (!show) return; // only run when modal opens

  // 1️⃣ Extract campaign ID immediately (no waiting for API)
  const path = location.pathname;
  let campaignId = null;

  if (path.startsWith("/donation/")) {
    campaignId = path.split("/donation/")[1];
  }

  if (campaignId) {
    setSelectedCenter(campaignId);
  }

  // 2️⃣ Then fetch all centers asynchronously (no delay for setting selectedCenter)
  dispatch(getAllCenters({ page: 1, limit: 1000 })).then((res) => {
    console.log("res",res?.centerList)
    if (res?.centersList) {
      setCenterList(res.centersList);
    }
  });
}, [show]);

  // ✅ 2. Prefill basic data
  useEffect(() => {
    if (!prefill) return;

    setEmail(prefill.email || "");
    setSelectedAmount(prefill.goalAmount || "");
    setFullName(prefill.contactPersonName || "");
  }, [prefill]);

  // ✅ 3. MAIN FIX → set selectedCenter ONLY when BOTH ready
  useEffect(() => {
    if (!prefill || centerList.length === 0) return;

    const today = new Date().toISOString().split("T")[0];
const RECIPIENTS = {
  TSU: "697ca12b3db12e71067fe880",
  PVAMU: "697ca1e03db12e71067fe88e",
  WALLER: "66f2a41ba8462a390b54d2b4"
};
    const createdLaunch =
      prefill.createdCampaignLaunchDate?.split("T")[0];
    const supportedLaunch =
      prefill.campaignLaunchDate?.split("T")[0];

    let selectedId = "";

    if (supportedLaunch === today) {
      console.log("today case");
      selectedId = prefill?.createdCampaignId;
    }else if (createdLaunch > today && supportedLaunch > today) {
    const validRecipients = Object.values(RECIPIENTS);

  if (validRecipients.includes(prefill?.campaignId)) {
    selectedId = prefill.campaignId;
  } else {
    selectedId = RECIPIENTS.WALLER; // fallback
  }
}
     else {
      console.log("supported campaign");
      selectedId = prefill?.campaignId;
    }

    console.log("FINAL SELECTED:", selectedId);

    setSelectedCenter(selectedId);
  }, [prefill, centerList]);

  // ✅ Debug correct way
  useEffect(() => {
    console.log("UPDATED selectedCenter:", selectedCenter);
  }, [selectedCenter]);

// useEffect(() => {
//   if (!prefill) return;

//   setEmail(prefill.email || "");
//   setSelectedAmount(prefill.goalAmount || "");
//   setFullName(prefill.contactPersonName)
// console.log("pre",prefill?.createdCampaignId)
//   // Check campaign launch date
//   if (prefill.campaignLaunchDate) {
//     const today = new Date().toISOString().split("T")[0];

//   const createdLaunch = prefill.createdCampaignLaunchDate?.split("T")[0];
//   const supportedLaunch = prefill.campaignLaunchDate?.split("T")[0];

//      if (supportedLaunch == today) {
//       console.log("today")
//     // Rule 1: campaign created today
//     setSelectedCenter(prefill?.createdCampaignId);
//     console.log("seklce",selectedCenter)
//   } 
//   else if (createdLaunch > today && supportedLaunch > today) {
//     console.log("both future")
//     // Rule 3: both campaigns future
//     setSelectedCenter("66f2a41ba8462a390b54d2b4");
//   } 
//   else {
//     console.log("suported")
//     // Rule 2: otherwise supported campaign
//     setSelectedCenter(prefill?.campaignId);
//   }

//   }

// }, [prefill]);
console.log("Selecteddd",selectedCenter)

  const handleDonate = () => {
    if (!amount) {
      toast.error("Please select a  amount for proceed the payment");
      return;
    }
    if (!email) {
      toast.error("Please enter the email address");
      return;
    }
    if (!fullName) {  // ← ADD THIS
  toast.error("Please enter your full name");
  return;
}

    const clearamount = amount.replace(/,/g, "");

    if (!isNaN(clearamount) && Number(clearamount) >= 0) {
       if (selectedFrequency == "1") {
        dispatch(
          AdminPayment({
            amount: amount,
            email: email,
            fullName: fullName,
            id: id,
            centerId:selectedCenter,
            usercomment: usercomment,
            sendInvoiceConsent: sendInvoiceConsent
          })
        ).then((res) => {
          if (res?.data) {
            window.location.href = res?.data;
          }
        });
      } else {
        dispatch(
          createAdminSubscription({
            amount: amount,
            interval: "month",
            email: email,
            fullName: fullName,
            centerId:selectedCenter,
            id: id,
          usercomment: usercomment,
             sendInvoiceConsent: sendInvoiceConsent
          })
        ).then((res) => {
          if (res?.url) {
            window.location.href = res?.url;
          }
        });
      }
    } else {
      toast.error("Invalid amount. Please enter a valid number.");
      return;
    }
  };



  useEffect(() => {
    const token = getToken();
    if (token) {
      const decoded = jwtDecode(token);
      setId(decoded?.sub);
    }
  }, []);

  // Save to localStorage
  useEffect(() => {
    localStorage.setItem("email", email);
    localStorage.setItem("amount", amount);
    localStorage.setItem("fullName", fullName);
  }, [email, amount, fullName]);

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Support the Global Life Fund",
          text: "Join me in supporting this life-affirming mission!",
          url: window.location.href,
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      alert("Sharing is not supported on your browser.");
    }
  };

  return (
    <>
      {/* Main Donate button */}
 

      {/* Modal */}
      <Modal
    show={show}
  onHide={onHide}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
       
        </Modal.Header>

        <Modal.Body>
        <div className={style.donationcontainermodal}>
        <div className="container">
          <div className={style.admininforcol}>
            <h1 className={style.supportadmin}>Join FundLife — Every Gift Helps Save a Life.</h1>
            <Row>
              <Col lg={6} md={12}>
                <div className={style.adminamountdonationmainmodal}>
                  <div className={style.labellinkmain}>
                    Enter a custom donation amount
                  </div>

                  <div className={style.customAmountInputdonation}>
                    <span className={style.currencydonation}>$</span>

                    <input
                      type="text"
                      value={amount}
                      placeholder="Enter custom amount"
                      onChange={(e) => setSelectedAmount(e.target.value)}
                      className={style.inputboxtextdonation}
                    />
                  </div>
                  <div className={style.labellinkcentermain}>
                        Select Campaign
                      </div>
                      <Form.Select
                        value={selectedCenter}
                        onChange={(e) => setSelectedCenter(e.target.value)}
                        className={style.informationinputcenterdonationmain}
                      >
                        <option value="">Select a campaign</option>
                        {centerList.map((center) => (
                          <option key={center._id} value={center._id}>
                            {center?.centerName}
                          </option>
                        ))}
                      </Form.Select>
                  <div className={style.labellinkemailmain}>Enter Name</div>

                  <div className={style.customAmountInput}>
                    <input
                      type="text"
                      placeholder="Full name"
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                      className={style.informationinputdonationmain}
                    />
                  </div>



                  <div className={style.labellinkemailmain}>Enter Email</div>

                  <div className={style.customAmountInput}>
                    <input
                      type="email"
                      placeholder="Email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className={style.informationinputdonationmain}
                     
                    />
                  </div>
                  <div className={style.labellinkemailmain}>Add a comment (optional)</div>
                  <div className={style.customAmountInput}>
                    <input
                      placeholder="Write your comment..."
                      value={usercomment}
                      onChange={(e) => setUserComment(e.target.value)}
                      className={style.informationinputdonationmain}
                      rows={3}
                    />
                  </div>
                    <div className={style.consentcheckbox}>
                        <input
                          type="checkbox"
                          id="invoiceConsent"
                          checked={sendInvoiceConsent}
                          onChange={(e) => setSendInvoiceConsent(e.target.checked)}
                            className={style.invoiceCheckbox}
                        />
                        <label htmlFor="invoiceConsent" className={style.labelinvoice} style={{color:"#fff"}}>
                          I would like to receive the tax deduction receipt.
                        </label>
                      </div>
                </div>
              </Col>

              <Col lg={6} md={12}>
                 <div className={style.adminpaymentformmaindonation}>
                  <div className={style.paymentFormdonationmodal}>
                    <div className={style.donationpaymentmain}>
                      <h3>Choose a donation frequency</h3>
                      <div className={style.donateradiomain}>
                        <div
                          className={
                            selectedFrequency === "1"
                              ? style.adminselectedLabel2main
                              : style.labeldonatemain
                          }
                        >
                          <div className={style.donationlabelmain}>
                            <label className={style.labelcontent}>
                              <input
                                type="radio"
                                name="frequency"
                                value="1"
                                checked={selectedFrequency === "1"}
                                onChange={handleFrequencyChange}
                                className={style.customRadio} // ✅ custom class here
                              />

                              <span>OneTime</span>
                            </label>
                          </div>
                        </div>

                        <div
                          className={
                            selectedFrequency === "month"
                              ? style.adminselectedLabel2main
                              : style.labeldonate2main
                          }
                        >
                          <div className={style.donationlabelmain}>
                            <label className={style.labelcontent}>
                              <input
                                type="radio"
                                name="frequency"
                                value="month"
                                checked={selectedFrequency === "month"}
                                onChange={handleFrequencyChange}
                                className={style.customRadio}
                              />

                              <span>Monthly</span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className={style.admindonationbuttoncontainermain1}>
                        <div className={style.smallscreenabutton}>
                          <button
                            onClick={handleDonate}
                          >
                            <img src="/logosstripe.png"></img>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

            </Row>
          </div>
        </div>
      </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DonateModal;
